export default __webpack_public_path__ + "static/maax-bold-webfont-d3c45b61c7a9c94cbeb25e6dc89f8b0c.woff";